import script from "./RichTextEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./RichTextEditor.vue?vue&type=script&setup=true&lang=js"

import "./RichTextEditor.vue?vue&type=style&index=0&id=1fc86fcc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fc86fcc"]])

export default __exports__